<template>
    <div class="bg-color-granite pb-10">
		<div class="d-flex justify-center align-center w-100 position-relative">
			<v-img class="w-100 h-100"			
				:height="199"
				aspect-ratio="16/9"
				src="https://dellpartnerincentives.com/siteassets/Images/HomePartner/Banner/bgRISE2.jpg"
			></v-img>
			<div class="position-absolute page-header">
				<h1><LanguagePlaceholder default-text="Latest News" /></h1>
			</div>			
		</div>
        <div class="bg-color-granite w-100 h-100">
            <div class="bg-color-granite w-auto h-100 my-2 mx-10" >
                <v-row no-gutters class="d-flex justify-center w-100 pa-0">
                <v-col cols="1" class="bg-color-quartz"></v-col>
                <v-col cols="10" class="bg-color-white d-flex justify-center w-100 pa-0 tx-font-bold">  
                    <div class="bg-color-white tx-font-bolder ma-0 pt-10 pb-7">
                        <v-row justify="center">
                            <v-col cols="12"  class="d-flex flex-no-wrap justify-center">
                                <v-card v-for="o in newsArticlesAdditional" :color="o.backgroundColor" class="w-100 elevation-0">
                                    <div class="d-flex flex-no-wrap justify-start">
                                        <div style="width:450px">
                                            <v-img :src="o.pictureUrl"></v-img>
                                        </div>
                        
                                        <div style="width:600px">
                                            <v-card-title class="general-heading text-white">
                                                <LanguagePlaceholder is-html
                                                    :default-text="o.heading" />
                                            </v-card-title>

                                            <v-card-text class="pt-4 text-montserrat">
                                                <LanguagePlaceholder is-html
                                                    :default-text="o.subHeading" />
                                                    <div style="position: relative;">
                                                        <v-btn density="compact" style="position: absolute; bottom:0; right:0" variant="text" @click="clickReadMore(o)" class="text-white text-none" color="white">
                                                            <LanguagePlaceholder is-html
                                                            default-text="Read More" />
                                                        </v-btn>                                        
                                                    </div>
                                            
                                            </v-card-text>                                
                                        </div>  
                                    </div>
                                </v-card>
                            </v-col>
                        </v-row>
                        <v-row  justify="center">
                            <v-col cols="12"  class="d-flex flex-no-wrap justify-center">
                                <v-card v-for="o in newsArticles" class="h1-100 elevation-0 mx-2 my-2" width="350"
                                
                                        :color="o.backgroundColor">
                                    <v-img class="mb-4" :src="o.pictureUrl" alt=""></v-img>
                                    <v-card-title class="general-heading text-white">
                                        <LanguagePlaceholder is-html
                                            :default-text="o.heading" />
                                    </v-card-title>
                                    <v-card-subtitle class="pt-4 news-anchor text-wrap">
                                        <LanguagePlaceholder is-html
                                            :default-text="o.subHeading" />

                                    </v-card-subtitle>
                                    <v-card-actions>
                                        <v-btn @click="clickReadMore(o)" class="text-white text-none" color="white">
                                            <LanguagePlaceholder is-html
                                                default-text="Read More" />
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-col>    
                        </v-row>
                        <!-- <v-row justify="center" v-if="systemStore.userDetail.userType === 'Partner'">
                            <v-col cols="12"  class="d-flex flex-no-wrap justify-center">
                                <v-card v-for="o in newsArticlesPartner" :color="o.backgroundColor" class="w-100 elevation-0">
                                    <div class="d-flex flex-no-wrap justify-start">
                                        <div style="width:450px">
                                            <v-img :src="o.pictureUrl"></v-img>
                                        </div>
                        
                                        <div style="width:600px">
                                            <v-card-title class="general-heading text-white">
                                                <LanguagePlaceholder is-html
                                                    :default-text="o.heading" />
                                            </v-card-title>

                                            <v-card-text class="pt-4 text-montserrat">
                                                <LanguagePlaceholder is-html
                                                    :default-text="o.subHeading" />
                                                    <div style="position: relative;">
                                                        <v-btn density="compact" style="position: absolute; bottom:0; right:0" variant="text" @click="clickReadMore(o)" class="text-white text-none" color="white">
                                                            <LanguagePlaceholder is-html
                                                            default-text="Read More" />
                                                        </v-btn>                                        
                                                    </div>
                                            
                                            </v-card-text>                                
                                        </div>  
                                    </div>
                                </v-card>
                            </v-col>
                        </v-row>
                        <v-row justify="center" v-if="systemStore.userDetail.userType === 'Distributor'">
                            <v-col cols="12"  class="d-flex flex-no-wrap justify-center">
                                <v-card v-for="o in newsArticlesDisti" :color="o.backgroundColor" class="w-100 elevation-0">
                                    <div class="d-flex flex-no-wrap justify-start">
                                        <div style="width:450px">
                                            <v-img :src="o.pictureUrl"></v-img>
                                        </div>
                        
                                        <div style="width:600px">
                                            <v-card-title class="general-heading text-white">
                                                <LanguagePlaceholder is-html
                                                    :default-text="o.heading" />
                                            </v-card-title>

                                            <v-card-text class="pt-4 text-montserrat">
                                                <LanguagePlaceholder is-html
                                                    :default-text="o.subHeading" />
                                                    <div style="position: relative;">
                                                        <v-btn density="compact" style="position: absolute; bottom:0; right:0" variant="text" @click="clickReadMore(o)" class="text-white text-none" color="white">
                                                            <LanguagePlaceholder is-html
                                                            default-text="Read More" />
                                                        </v-btn>                                        
                                                    </div>
                                            
                                            </v-card-text>                                
                                        </div>  
                                    </div>
                                </v-card>
                            </v-col>
                        </v-row> -->
                    </div>            
                </v-col>
                
                <v-col cols="1" class="bg-color-quartz"></v-col>
                </v-row>
            </div>
        </div>
    </div>

</template>

<script setup>
import { ref, onMounted } from 'vue'
import LanguagePlaceholder from '@/components/LanguagePlaceholder.vue'
import { useSystemStore } from '@/stores/system'

const systemStore = useSystemStore()

const selectedTab = ref(0)

const languageCode = ref('EN')

onMounted(() => {
    languageCode.value = systemStore.selectedLanguage.toUpperCase()
    
    if (systemStore.userDetail.userType === 'Partner' || systemStore.userDetail.userType === 'TIC_Admin') {
        newsArticles.value.push({ backgroundColor: "#491939", heading: 'Welcome to the new quarter.'
        , subHeading: "There's up to $15,000 in rewards. RISE up and grab it."
        , pictureUrl: 'https://www.dellpartnerincentives.com/siteassets/Images/News/Launch.jpeg'
        , readMoreContentUrl: 'https://www.dellpartnerincentives.com/siteassets/Images/News/Launch.html', clickEvent: undefined })
    }
    if (systemStore.userDetail.userType === 'Partner') {
        
    }
    if (systemStore.userDetail.userType === 'Distributor') {
       
    }
    //newsArticles.value.push({ backgroundColor: "#00227F", heading: 'Offers that drive more sales!', subHeading: 'Take advantage of these deals!', pictureUrl: 'https://dellpartnerincentives.com/siteassets/Images/News/DNCP.jpeg', readMoreContentUrl: 'https://dellpartnerincentives.com/resources/DnCP%20Promotions.pdf', clickEvent: undefined })
    newsArticles.value.push({ backgroundColor: "#0D2154", heading: '0% Interest Financing', subHeading: 'Simplicity with Dell Technologies Payment Solutions', pictureUrl: 'https://dellpartnerincentives.com/siteassets/Images/News/NewsAndPromotionBannerItem4News.jpg', readMoreContentUrl: `https://dellpartnerincentives.com/siteassets/Documents/Financing_${languageCode.value}.pdf`, clickEvent: undefined })
})

const openLaunchArticle = () => {
    if (systemStore.userDetail.userType === 'Partner') {
        systemStore.openUrl('https://dellpartnerincentives.com/files/LaunchMailer/PartnerLaunch.html')
    } else if (systemStore.userDetail.userType === 'Distributor') {
        systemStore.openUrl('https://dellpartnerincentives.com/files/LaunchMailer/DistributorLaunch.html')
    } else {
        systemStore.openUrl('https://dellpartnerincentives.com/files/LaunchMailer/PartnerLaunch.html')
    }
}

const newsArticles = ref([
])

const newsArticlesAdditional = ref([
      { backgroundColor: "#1A237E", heading: 'Unlock the latest Dell Technologies innovations'
      , subHeading: '<b>Join the EMEA Client Solutions Monthly Channel Webinar Series</b> to stay ahead with the<br>latest Dell Technologies innovations, channel updates, and industry insights.<br>When: Every 3rd Tuesday of the month. Topic titles subject to change.<br><br><b>Don’t miss this opportunity to:</b><br>• Get first-hand product insights<br>• Stay current on partner incentives and promotions<br>• Hear from Dell experts and industry leaders<br><br>'
      , pictureUrl: 'https://dellpartnerincentives.com/siteassets/Banners/bonus/RISE CSG Webinar Banner.jpg'
      , readMoreContentUrl: 'https://dellpartnerincentives.com/siteassets/Banners/bonus/EMEA Client Solutions Monthly Channel Webinar Series.pdf', clickEvent: undefined },
])

// const newsArticlesPartner = ref([
//       { backgroundColor: "#0d32a4", heading: 'What\'s new in RISE?'
//       , subHeading: 'Sign up for the Webinar!'
//       , pictureUrl: 'https://www.dellpartnerincentives.com/siteassets/Images/News/RISEPartnerWebinar.jpg'
//       , readMoreContentUrl: 'https://www.dellpartnerincentives.com/siteassets/Images/News/RISEPartnerWebinar.html', clickEvent: undefined },
// ])

// const newsArticlesDisti = ref([
//       { backgroundColor: "#84133f", heading: 'What\'s new in RISE?'
//       , subHeading: 'Sign up for the Webinar!'
//       , pictureUrl: 'https://www.dellpartnerincentives.com/siteassets/Images/News/RISEDistiWebinar.jpg'
//       , readMoreContentUrl: 'https://www.dellpartnerincentives.com/siteassets/Images/News/RISEDistiWebinar.html', clickEvent: undefined },
// ])

const clickReadMore = (o) => {
    if (o.clickEvent !== undefined) {
        o.clickEvent()
    } else {
        systemStore.openUrl(o.readMoreContentUrl)
    }
}

</script>

<style scoped>
.v-slide-group-item--active {
    background-color: #359f60;
}

.text-montserrat {
  font-family: "Montserrat", sans-serif;
  font-optical-sizing: auto;
  font-weight: 100;
  font-style: normal;
  font-size: 12px;
}

.news-anchor {
    text-decoration: none;
    color: #FFFFFF;
    
    font-weight: 300;
    font-size: 12px;
}
</style>